/* WINGBABE · mega-menu · vanilla JS, no dependencies */
(function(){
var menu=document.querySelector('[data-mega-menu]');if(!menu)return;
var trig=document.querySelector('[data-mega-trigger]'),tog=document.querySelector('[data-menu-toggle]'),header=menu.closest('header');
function open(){menu.classList.add('is-open');if(tog)tog.setAttribute('aria-expanded','true');if(trig)trig.setAttribute('aria-expanded','true');}
function close(){menu.classList.remove('is-open');if(tog)tog.setAttribute('aria-expanded','false');if(trig)trig.setAttribute('aria-expanded','false');}
var desk=window.matchMedia('(min-width:761px)'),t;
if(trig){trig.setAttribute('aria-haspopup','true');trig.setAttribute('aria-expanded','false');
 trig.addEventListener('mouseenter',function(){if(desk.matches){clearTimeout(t);open();}});
 trig.addEventListener('click',function(e){if(!desk.matches)return;e.preventDefault();menu.classList.contains('is-open')?close():open();});}
if(header)header.addEventListener('mouseleave',function(){if(desk.matches)t=setTimeout(close,150);});
menu.addEventListener('mouseenter',function(){clearTimeout(t);});
if(tog)tog.addEventListener('click',open);
document.querySelectorAll('[data-menu-close]').forEach(function(b){b.addEventListener('click',close);});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();
